exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".my-custom-scrollbar{position:relative;height:550px;overflow:auto}.my-custom-scrollbar_xAxis{position:relative;height:340px;overflow:auto}.table-wrapper-scroll-y{display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ed757818","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/common/quotationSummary.vue
// module id = 1839
// module chunks = 0